import { render, staticRenderFns } from "./EditNotificationTemplate.vue?vue&type=template&id=136ca422"
import script from "./EditNotificationTemplate.vue?vue&type=script&lang=js"
export * from "./EditNotificationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports